<div id="elevaagendaedu" *ngIf="isResponsibleDataLoaded()">
  <eae-header-navigation href="" title=""></eae-header-navigation>
  <eae-ficha-financeira [listaFaturas]="listaFaturas"></eae-ficha-financeira>
</div>
